<div class="modal-header">
  <h4 class="modal-title">
    @if (amenity) {
      Editar {{ amenity.name }}
    }

    @if (!amenity) {
      Nueva amenidad
    }
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  @if (!loading) {
    <form
      id="formAmenity"
      [formGroup]="formAmenity"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @if(imageBase64 || (amenity && amenity.image)) {
            <div class="col-12">
              <img [src]="imageBase64 ? imageBase64 : (amenity && amenity!.image) ? amenity.image.urlFile : ''" width="100%">
            </div>
          }

          @for (key of utilService.objectKeys(dataForm); track key) {
            @if (
              dataForm[key].type == "text"
            ) {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }

            @if (
              dataForm[key].type == "number"
            ) {

              <div class="col-12">
                <div class="row">

                  <div class="col-12 mb-2">
                    {{ dataForm[key].label }}
                  </div>

                  <p-inputNumber
                    [formControlName]="key"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    spinnerMode="horizontal"
                    styleClass="w-100 mb-4"
                    min="0"
                    decrementButtonClass="p-button-secondary"
                    incrementButtonClass="p-button-secondary"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus" />

                </div>
              </div>

            }

            @if(dataForm[key].type == 'image') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  class="form-control"
                  type="file"
                  accept="image/*"
                  [id]="key"
                  (change)="onFileChange($event)">
              </div>
            }

            @if (dataForm[key].type === 'switch') {
              <div class="col-12 mt-2 mb-4">
                <div class="row">
                  <div class="col-8">
                    {{ dataForm[key].label }}
                  </div>
                  <div class="col-4 text-end">
                    <p-inputSwitch
                      formControlName="{{ key }}">
                    </p-inputSwitch>
                  </div>
                </div>
              </div>
            }

            @if (dataForm[key].type === 'textarea') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <textarea
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }"></textarea>
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }
          }

          @if(amenity && amenity.regulation) {
            <div class="col-12 mb-3">
              <label class="form-label fw-semibold">Reglamento actual</label>
              @if(amenity.regulation.fileType === 'pdf') {
                <div>
                  <a
                    [href]="amenity.regulation.urlFile"
                    target="_blank"
                    class="btn btn-outline-secondary btn-sm">
                    <i class="material-icons" style="vertical-align: middle; font-size: 16px;">picture_as_pdf</i>
                    Ver reglamento (PDF)
                  </a>
                </div>
              }
              @if(amenity.regulation.fileType !== 'pdf') {
                <img [src]="amenity.regulation.urlFile" width="100%" class="rounded">
              }
            </div>
          }

          @if(selectedRegulationFile) {
            <div class="col-12 mb-3">
              <label class="form-label fw-semibold">Nuevo reglamento seleccionado</label>
              <div class="alert alert-info py-2 mb-0">
                <i class="material-icons" style="vertical-align: middle; font-size: 16px;">picture_as_pdf</i>
                {{ selectedRegulationFile.name }}
              </div>
            </div>
          }

          <div class="col-12 form-group mb-4">
            <label class="form-label">Reglamento (PDF — Opcional)</label>
            <input
              class="form-control"
              type="file"
              accept="application/pdf"
              (change)="onRegulationFileChange($event)">
            <div class="form-text">Solo PDF, máximo 3 MB</div>
          </div>

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formAmenity"
      class="btn btn-primary w-100">
      {{ amenity ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
